import { baseState, baseMutations } from '@/store/mixins'
import hospitalProfile from '@/api/hospital-profile'

export const state = {
  ...baseState
}
export const getters = {}
export const mutations = {
  ...baseMutations
}

export const actions = {
  fetch (context, attributes = {}) {
    const params = Object.assign(
      {
        page: context.state.pagination.page,
        perPage: context.state.pagination.perPage,
        search: context.state.search
      },
      attributes
    )

    return hospitalProfile.get({ params }).then(response => {
      context.commit('RECEIVE_RESOURCES', response)
      return Promise.resolve(response)
    })
  },
  create (context, data) {
    return hospitalProfile.store(data)
  },
  update (context, data) {
    return hospitalProfile.update(data)
  },
  delete (context, data) {
    return hospitalProfile.destroy(data)
  }
}
